import React from "react";
import "@/App.css";
import "@/styles/theme.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import MatrixPage from "@/pages/MatrixPage";
import AdminPage from "@/pages/AdminPage";
import AuthPage from "@/pages/AuthPage";
import PublicProposalPage from "@/pages/PublicProposalPage";
import WorkspaceLayout from "@/components/workspace/WorkspaceLayout";
import TenantsPage from "@/pages/workspace/TenantsPage";
import TenantDetailPage from "@/pages/workspace/TenantDetailPage";
import CompliancePage from "@/pages/workspace/CompliancePage";
import ComplianceTenantPage from "@/pages/workspace/ComplianceTenantPage";
import UsersPage from "@/pages/workspace/UsersPage";
import SettingsPage, { ChangePasswordPage } from "@/pages/workspace/SettingsPage";
import useTheme, { ThemeProvider } from "@/hooks/useTheme";
import useAuth, { AuthProvider, RequireAuth } from "@/hooks/useAuth";

function ThemedToaster() {
  const { theme } = useTheme();
  return <Toaster position="bottom-right" richColors closeButton theme={theme} />;
}

function PublicOnly({ children }) {
  const { session, user } = useAuth();
  if (session === undefined) return null;
  return user ? <Navigate to="/app" replace /> : children;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<MatrixPage />} />
              <Route path="/matrix" element={<MatrixPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/p/:token" element={<PublicProposalPage />} />
              <Route
                path="/login"
                element={
                  <PublicOnly>
                    <AuthPage mode="login" />
                  </PublicOnly>
                }
              />
              <Route
                path="/register"
                element={
                  <PublicOnly>
                    <AuthPage mode="register" />
                  </PublicOnly>
                }
              />
              <Route
                path="/app"
                element={
                  <RequireAuth>
                    <WorkspaceLayout />
                  </RequireAuth>
                }
              >
                <Route index element={<Navigate to="/app/tenants" replace />} />
                <Route path="tenants" element={<TenantsPage />} />
                <Route path="tenants/:id" element={<TenantDetailPage />} />
                <Route path="compliance" element={<CompliancePage />} />
                <Route path="compliance/:id" element={<ComplianceTenantPage />} />
                <Route
                  path="users"
                  element={
                    <RequireAuth admin>
                      <UsersPage />
                    </RequireAuth>
                  }
                />
                <Route path="settings" element={<SettingsPage />} />
                <Route path="change-password" element={<ChangePasswordPage />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <ThemedToaster />
        </div>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
